






























import Vue from 'vue';
import { editEntityDialog, PREF_FULLSCREEN_EDIT_ALIASED } from './EditEntity';
import { Preferences } from './Preference';


export default Vue.extend({
  data: () => editEntityDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    title(): string {
      return this.name ? 'Edit Entity' : 'Add Entity';
    },
    isSaved(): boolean {
      return this.registry.defs.getEntity(this.entity.name) === this.entity;
    },
    buttonText(): string {
      return this.isSaved ? this.confirm : this.unconfirm;
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_EDIT_ALIASED, this.fullscreen);
    },
    finish() {
      this.done(this.isSaved);
    },
    removed() {
      this.done(false);
    },
  },
});
